// Authors: Ben Croker
// Icon: tabler:typography
// Slug: Set the text content of an element to a reactive JSON stringified version of all signals
// Description: This attribute sets the text content of an element to a reactive JSON stringified version of all signals.

import type {
  AttributePlugin,
  SignalFilterOptions,
} from '../../../engine/types'
import { jsStrToObject } from '../../../utils/text'

export const JsonSignals: AttributePlugin = {
  type: 'attribute',
  name: 'jsonSignals',
  keyReq: 'denied',
  onLoad: ({ el, root, value, effect, filtered, mods }) => {
    const spaces = mods.has('terse') ? 0 : 2
    const observer = new MutationObserver(() => {
      observer.disconnect()
      el.textContent = JSON.stringify(root, null, 2)
      observer.observe(el, {
        childList: true,
      })
    })

    let filters: SignalFilterOptions = {}
    if (value.length) {
      filters = jsStrToObject(value)
    }

    const cleanup = effect(() => {
      observer.disconnect()
      const filteredSignals = filtered(filters)
      el.textContent = JSON.stringify(filteredSignals, null, spaces)
      observer.observe(el, {
        childList: true,
      })
    })

    return () => {
      observer.disconnect()
      cleanup()
    }
  },
}
